import { render, staticRenderFns } from "./MnWrapper.vue?vue&type=template&id=4f5261c4&"
import script from "./MnWrapper.vue?vue&type=script&lang=js&"
export * from "./MnWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports